import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import Favicon from 'react-favicon';
import { useTranslation } from 'react-i18next';
import { Button, Dimmer } from 'semantic-ui-react';
import AuthService from '~/api/services/auth';
import LoaderMilkCan from '~/components/Loader';
import notify from '~/components/Notify';
import { ThemeContext } from 'styled-components';
import { El, StyledSegment } from './style';
import { b64toBlob, handleErrors } from '~/utils/helpers';
import Dialog from '~/components/Dialog';
interface LayoutAuthProps {
  children: React.ReactNode
  isLoading?: boolean
}

const LayoutAuth: React.FC<LayoutAuthProps> = (props) => {
  const { t } = useTranslation()
  const { isLoading, children } = props
  const [isBusy, setIsBusy] = useState(false)
  const [coverImage, setCoverImage] = useState('');
  const [faviconImage, setFaviconImage] = useState('');
  const [loadingData, setLoadingData] = useState(false);
  const [fileSource, setFileSource] = useState(null);
  const localTheme = localStorage.getItem('theme')
  const contextData = useContext(ThemeContext)
  const settingsData = contextData && JSON.stringify(contextData) !== localTheme ? JSON.parse(localTheme) : contextData
  const [settingsDataFiles, setSettingsDataFiles] = useState(settingsData?.files || [])

  useEffect(() => {
    const localLang = localStorage.getItem('i18nextLng')
    if (settingsData?.files?.length > 0 && settingsData?.files[0]?.code !== localLang) {
      fetchNewStorageData()
    }
  }, [])

  async function fetchNewStorageData() {
    try {
      const localLang = localStorage.getItem('i18nextLng')
      const responseTermsData = await AuthService.getSettingsData({ languageCode: localLang || 'de' })
      setSettingsDataFiles(responseTermsData.data?.files || [])
    } catch (error) {
      // dont display error
    }
  }

  async function fetchLandingPageData() {
    setLoadingData(true);
    try {
      const responseCoverImage = await AuthService.getCoverImage();
      setCoverImage(responseCoverImage.data);
      const responseFaviconImage = await AuthService.getFavicon();
      setFaviconImage(responseFaviconImage.data);
    } catch (error) {
      // dont display error
    }
    setLoadingData(false);
  }

  function refreshPage() {
    fetchLandingPageData();
  }

  async function handleDownloadFile(fileName, fileType, id = null) {
    setIsBusy(id);
    try {
      if (fileType === 'file') {
        const response = await AuthService.getTermFile({
          fileName: fileName
        });
        const type = response.data.split(';')[0].split('data:')[1]
        const blob = b64toBlob(response.data, type);
        const blobUrl = URL.createObjectURL(blob);
        setFileSource(blobUrl);
      } else {
        setFileSource(fileName);
      }
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  }

  function renderModalPreviewFile() {
    return (
      <Dialog
        open={Boolean(fileSource)}
        handleClose={() => setFileSource(null)}
        textContent={<iframe width='100%' height='100%' src={fileSource}></iframe>}
        textHeader={t('Preview')}
        textClose={t('Close')}
        type={'preview'}
      />
    );
  }

  function coverDidNotLoad() {
    return <>
      <El.defaultBackground>
        <h1></h1>
        <El.FormLogo>{t('Sorry, we couldn\'t load your cover image')}</El.FormLogo>
        <Button
          style={{
            ...El.loginFormSubmitButton,
            backgroundColor: `${settingsData?.firstColor}`
          }}
          primary
          content={t('Retry')}
          onClick={refreshPage}
        />
      </El.defaultBackground>
      <Favicon url='assets\images\milking-cartoon-transparent.png' />
      <El.LandingPageForm style={{ width: '420px', marginLeft: 'unset' }}>
        <Dimmer inverted active={isLoading}>
          <LoaderMilkCan isLoading={isLoading} />
        </Dimmer>
        {children}
        {settingsDataFiles.map((item) => item.fileType === 'file' ? renderFileType(item) : renderItem(item))}
      </El.LandingPageForm>
    </>
  }

  function renderFileType(item) {
    return <El.FormTermsAndPrivacy
      style={{ color: `${settingsData?.firstColor}` }}
      key={item.id}
      target='blank'
      onClick={() => handleDownloadFile(item.filename, item.fileType, item.id)}
    >
      <StyledSegment loading={isBusy === item.id}>
        {item.name}
      </StyledSegment>
    </El.FormTermsAndPrivacy>
  }

  function renderItem(item) {
    return <El.FormTermsAndPrivacy
      style={{ color: `${settingsData?.firstColor}` }}
      key={item.id}
      target='blank'
      href={item.link}
    >
      {item.name}
    </El.FormTermsAndPrivacy>
  }

  function coverLoaded() {
    return <>
      <Favicon url={settingsData?.favIcon} />
      <El.LandingPageForm>
        <Dimmer inverted active={props.isLoading}>
          <LoaderMilkCan isLoading={props.isLoading} />
        </Dimmer>
        <div style={{ margin: 'auto' }}>
          {props.children}
          <El.LandingPageFormFotter>
            <El.FormCompanyNameVersion style={{ color: `${settingsData?.firstColor}` }}>
              <p style={{ maxWidth: 200, whiteSpace: 'break-spaces' }}>{`© ${settingsData?.companyName}`}</p>
              <p>
                {settingsData?.version?.version || '1.0'}
                {'  '}
                {dayjs(settingsData?.version?.date || new Date()).format('DD.MM.YYYY')}
              </p>
            </El.FormCompanyNameVersion>
            <El.FormTermsWrapper>
              {settingsDataFiles.map((item) => item.fileType === 'file' ? renderFileType(item) : renderItem(item))}
            </El.FormTermsWrapper>
          </El.LandingPageFormFotter>
        </div>
      </El.LandingPageForm>
    </>
  }

  /* if (loadingData) {
    return <Dimmer inverted active={loadingData}>
      <LoaderMilkCan isLoading={loadingData} />
    </Dimmer>
  }
 */

  return <>

    <El.LandingPageContainer
      url={settingsData?.cover}
    >
      <Favicon url={settingsData?.favIcon || ''} />
      {!settingsData?.cover ? loadingData ? null : coverDidNotLoad() : coverLoaded()}
    </El.LandingPageContainer>
    {fileSource && renderModalPreviewFile()}
  </>
}
export default LayoutAuth
